import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { MaterialModule } from './material.module';

const classesToInclude = [
    BottomSheetComponent,
   
  ]

@NgModule({
    declarations: classesToInclude,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    MaterialModule,
  ],
  entryComponents: [BottomSheetComponent],
  exports: [
    classesToInclude,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    MaterialModule,
  ],
})
export class SharedModule {}
